<div class="vrijeme-kompleksni-range">
    <ng-container *ngIf="showInOverlay; else widget">
        <p-button
            (click)="overlayPanel.toggle($event); button.icon = (button.icon && button.icon.indexOf('plus') > 0) ? 'pi pi-minus-circle' : 'pi pi-plus-circle'"
            icon="pi pi-plus-circle" #button></p-button>
        <p-overlayPanel #overlayPanel>
            <ng-container *ngTemplateOutlet="widget"></ng-container>
        </p-overlayPanel>
    </ng-container>
    <ng-template #widget>
        <ng-container *ngIf="!this.inputParam.attributeMetadata.read_only; else isReadOnly">

            <app-vrijeme-strukturirani [inputParam]="inputParamFrom" [range]="true" [od]="true"
                [(selectedOption)]="selectedOption"></app-vrijeme-strukturirani>
            <div class="crtica">
                -
            </div>
            <app-vrijeme-strukturirani class="do" [inputParam]="inputParamTo" [range]="true" [od]="false"
                [(selectedOption)]="selectedOption"></app-vrijeme-strukturirani>
        </ng-container>

        <ng-template #isReadOnly>
            {{this.getVrijemeNastankaLabel()}}
        </ng-template>
        <p-dropdown class="mjerna-jedinica" [options]="options" [(ngModel)]="selectedOption"
            [hidden]="this.inputParam.attributeMetadata.read_only" [disabled]="this.inputParam.attributeMetadata.read_only"></p-dropdown>
    </ng-template>
</div>